var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 17,
    viewBox: "0 0 32 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3196 0.49712C2.48958 -0.231677 1.22592 -0.14962 0.49712 0.680398C-0.231677 1.51042 -0.14962 2.77408 0.680398 3.50288L3.3196 0.49712ZM14.3401 15.4967L15.8429 16.8163L18.4822 13.8106L16.9793 12.491L14.3401 15.4967ZM0.680398 3.50288L14.3401 15.4967L16.9793 12.491L3.3196 0.49712L0.680398 3.50288Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6804 0.49712C29.5104 -0.231677 30.7741 -0.14962 31.5029 0.680398C32.2317 1.51042 32.1496 2.77408 31.3196 3.50288L28.6804 0.49712ZM17.6599 15.4967L16.1571 16.8163L13.5178 13.8106L15.0207 12.491L17.6599 15.4967ZM31.3196 3.50288L17.6599 15.4967L15.0207 12.491L28.6804 0.49712L31.3196 3.50288Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/Down Arrow.53fc446b66cd5b34315727c5a8f94c19.svg";
export { ForwardRef as ReactComponent };